import React from 'react';
import Aac from './Aac';
import Ai from './Ai';
import Avi from './Avi';
import Csv from './Csv';
import Doc from './Doc';
import Docx from './Docx';
import Empty from './Empty';
import Fla from './Fla';
import Flac from './Flac';
import Gif from './Gif';
import Htm from './Htm';
import Html from './Html';
import Jpeg from './Jpeg';
import Jpg from './Jpg';
import Mov from './Mov';
import Mp3 from './Mp3';
import Mp4 from './Mp4';
import Pdf from './Pdf';
import Png from './Png';
import Ppt from './Ppt';
import Ps from './Ps';
import Tiff from './Tiff';
import Txt from './Txt';
import Xls from './Xls';
import Xlsx from './Xlsx';
import Xml from './Xml';
const FileTypes = {
    aac: Aac,
    ai: Ai,
    avi: Avi,
    csv: Csv,
    doc: Doc,
    docx: Docx,
    fla: Fla,
    flac: Flac,
    gif: Gif,
    htm: Htm,
    html: Html,
    jpg: Jpg,
    jpeg: Jpeg,
    mov: Mov,
    mp3: Mp3,
    mp4: Mp4,
    pdf: Pdf,
    png: Png,
    ps: Ps,
    tiff: Tiff,
    txt: Txt,
    xls: Xls,
    xlsx: Xlsx,
    xml: Xml,
    pptx: Ppt,
};
export const availableFileTypes = Object.keys(FileTypes);
const isSupported = (type) => !!FileTypes[type];
const FileType = ({ type, ...props }) => {
    if (isSupported(type)) {
        return React.createElement(FileTypes[type], props);
    }
    return React.createElement(Empty, props);
};
export default React.memo(FileType);
